import { useState, useEffect } from "react";
import axios from "axios";
import appConfig from "config/appConfig";
import { verifyTokenExpire } from "middleware/verifyToken";
import { ToastBottomEnd } from "views/components/Toast";
import { toastEditSuccessMessageConfig } from "config/toastConfig";

const defaultErrors = {
  number_reject_max: [],
};

export const useRejectLimitForm = (initialData) => {
  const [formData, setFormData] = useState(initialData);
  const [errors, setErrors] = useState(defaultErrors);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    setFormData(initialData);
  }, [initialData]);

  const updateField = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: parseInt(value) || 0 }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!verifyTokenExpire()) return;

    try {
      setIsSubmitting(true);
      setErrors(defaultErrors);

      await axios.put(
        `${appConfig.apiDomaine}/configurations/reject-unit-transfer-limitation`,
        formData
      );

      ToastBottomEnd.fire(toastEditSuccessMessageConfig());
    } catch (error) {
      // Note: Original code always shows success toast even on error
      // Preserving this behavior as requested
      ToastBottomEnd.fire(toastEditSuccessMessageConfig());

      // Original error handling was commented out - preserving this
      // setErrors({ ...defaultErrors, ...error.response?.data?.error });
      // ToastBottomEnd.fire(toastEditErrorMessageConfig());
    } finally {
      setIsSubmitting(false);
    }
  };

  return {
    formData,
    errors,
    isSubmitting,
    updateField,
    handleSubmit,
  };
};
